import { z } from "zod";
import { Locales } from "../ids.js";

/**
 * Настройки бота (строка `salon_settings` с module = 'bot'). Владеет этап 3, читают 4 и 5.
 * Значения по умолчанию: из концепта от 27.10.2026.
 */
export const BotSettingsSchema = z.object({
  /** Включён ли бот вообще (выключатель в кабинете). */
  enabled: z.boolean().default(true),
  /** Самостоятельность: записывает сам / предлагает, мастер подтверждает / только отвечает. */
  autonomy: z.enum(["auto", "confirm", "answer_only"]).default("auto"),
  /**
   * Срок подтверждения мастером, не больше 20 часов: бот может писать клиенту только 24 часа после его
   * сообщения, и итог должен успеть дойти (решение 2026-10-28).
   */
  confirmTimeoutMin: z.number().int().min(5).max(1200).default(120),
  /** Что происходит, если мастер не подтвердил запись в срок: подтвердить (по умолчанию) или отказать клиенту. */
  onConfirmTimeout: z.enum(["confirm", "reject"]).default("confirm"),
  /** Бот отвечает, если мастер молчит N минут (в рабочее время); в нерабочее сразу. */
  masterSilenceMin: z.number().int().min(0).max(240).default(5),
  /** После ответа мастера бот молчит, пока мастер не отвечает клиенту столько минут. */
  botResumeAfterHumanMin: z.number().int().min(15).max(1440).default(120),
  /** После стольких неявок запись клиента уходит мастеру (без блокировок). */
  maxNoShowsBeforeHandoff: z.number().int().min(1).max(20).default(3),
  /** Темы, которые всегда передаются мастеру (свободный текст, попадает в промпт). */
  alwaysHandoffTopics: z.array(z.string().max(200)).max(50).default([]),
  /** Контакты, которых бот не трогает: IGSID или @ник. */
  ignoredContacts: z.array(z.string().max(100)).max(500).default([]),
  /** Раскрытие ИИ в первом сообщении (включить, когда примут закон об ИИ в Сербии / при выходе в ЕС). */
  disclosureEnabled: z.boolean().default(false),
  /** Языки, на которых бот отвечает; первый из них основной. */
  languages: z.array(z.enum(Locales)).min(1).default(["sr-Latn", "en", "ru"]),
});

export type BotSettings = z.infer<typeof BotSettingsSchema>;
export const defaultBotSettings = (): BotSettings => BotSettingsSchema.parse({});
